import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { projectDelete } from '../../api';

const useProjectDelete = (projectId: string, options?: UseMutationOptions) =>
	useMutation(() => projectDelete(projectId).then((response) => response.expectSuccess()), options);

export default useProjectDelete;
